import axios from 'axios';
import { push } from 'connected-react-router';
import { flashMessage } from 'redux-flash';
import Bugsnag from '@bugsnag/js';

export const FETCH_SUBMISSION_REQUEST = 'FETCH_SUBMISSION_REQUEST';
export const FETCH_SUBMISSION_SUCCESS = 'FETCH_SUBMISSION_SUCCESS';
export const FETCH_SUBMISSION_FAILURE = 'FETCH_SUBMISSION_FAILURE';

export const SUBMIT_SUBMISSION_REQUEST = 'SUBMIT_SUBMISSION_REQUEST';
export const SUBMIT_SUBMISSION_SUCCESS = 'SUBMIT_SUBMISSION_SUCCESS';
export const SUBMIT_SUBMISSION_FAILURE = 'SUBMIT_SUBMISSION_FAILURE';

export const VERIFY_SUBMISSION_REQUEST = 'VERIFY_SUBMISSION_REQUEST';
export const VERIFY_SUBMISSION_SUCCESS = 'VERIFY_SUBMISSION_SUCCESS';
export const VERIFY_SUBMISSION_FAILURE = 'VERIFY_SUBMISSION_FAILURE';

export const FETCH_FAILED_SUBMISSION_REQUEST = 'FETCH_FAILED_SUBMISSION_REQUEST';
export const FETCH_FAILED_SUBMISSION_SUCCESS = 'FETCH_FAILED_SUBMISSION_SUCCESS';
export const FETCH_FAILED_SUBMISSION_FAILURE = 'FETCH_FAILED_SUBMISSION_FAILURE';

export const UPDATE_FAILED_SUBMISSION_REQUEST = 'UPDATE_FAILED_SUBMISSION_REQUEST';
export const UPDATE_FAILED_SUBMISSION_SUCCESS = 'UPDATE_FAILED_SUBMISSION_SUCCESS';
export const UPDATE_FAILED_SUBMISSION_FAILURE = 'UPDATE_FAILED_SUBMISSION_FAILURE';

export const FETCH_BANK_NAME_SUCCESS = 'FETCH_BANK_NAME_SUCCESS';

function fetchSubmissionRequest() {
  return {
    type: FETCH_SUBMISSION_REQUEST
  }
}

function fetchSubmissionSuccess(submission) {
  return {
    type: FETCH_SUBMISSION_SUCCESS,
    submission
  }
}

function fetchSubmissionFailure(error) {
  return {
    type: FETCH_SUBMISSION_FAILURE,
    error: error
  }
}

function submitSubmissionRequest() {
  return {
    type: SUBMIT_SUBMISSION_REQUEST
  }
}

function submitSubmissionSuccess(submission) {
  return {
    type: SUBMIT_SUBMISSION_SUCCESS,
    submission
  }
}

function submitSubmissionFailure() {
  return {
    type: SUBMIT_SUBMISSION_FAILURE
  }
}

function verifySubmissionRequest() {
  return {
    type: VERIFY_SUBMISSION_REQUEST
  }
}

function verifySubmissionSuccess(submission) {
  return {
    type: VERIFY_SUBMISSION_SUCCESS,
    submission
  }
}

function verifySubmissionFailure() {
  return {
    type: VERIFY_SUBMISSION_FAILURE
  }
}

function fetchFailedSubmissionRequest() {
  return {
    type: FETCH_FAILED_SUBMISSION_REQUEST
  }
}

function fetchFailedSubmissionSuccess(submission) {
  return {
    type: FETCH_FAILED_SUBMISSION_SUCCESS,
    submission
  }
}

function fetchFailedSubmissionFailure(error) {
  return {
    type: FETCH_FAILED_SUBMISSION_FAILURE
  }
}

function fetchBankNameSuccess(bank_name) {
  return {
    type: FETCH_BANK_NAME_SUCCESS,
    bank_name
  }
}

function updateFailedSubmissionRequest() {
  return {
    type: UPDATE_FAILED_SUBMISSION_REQUEST
  }
}

function updateFailedSubmissionSuccess(submission) {
  return {
    type: UPDATE_FAILED_SUBMISSION_SUCCESS
  }
}

function updateFailedSubmissionFailure() {
  return {
    type: UPDATE_FAILED_SUBMISSION_FAILURE
  }
}

export function fetchSubmission(promotionId, trackingId, captchaResponse) {
  return dispatch => {
    dispatch(fetchSubmissionRequest());
    return axios.get('/promotions/' + promotionId + '/submissions/' + trackingId, {params: {captcha_response: captchaResponse}})
      .then(response => {
        dispatch(fetchSubmissionSuccess(response.data.submission));
      }).catch(error => {
        dispatch(fetchSubmissionFailure(error.response.data.error));
      });
  }
}

export function submitSubmission(promotionId, data) {
  return dispatch => {
    dispatch(submitSubmissionRequest());
    return axios.post('/promotions/' + promotionId + '/submissions', {submission: data})
      .then(response => {
        dispatch(submitSubmissionSuccess(response.data.submission));
        if (response.data.submission?.verification_required) {
          // MFA flow
          dispatch(push('/verify'));
        } else {
          dispatch(push('/thanks'));
        }
      }).catch(error => {
        dispatch(submitSubmissionFailure());
        if (error.response.data.error) {
          dispatch(flashMessage(error.response.data.error, {isError: true}));
        } else {
          dispatch(flashMessage('Unfortunately, your submission was unsuccessful', {isError: true}));

          // Notify Bugsnag of errors
          if (window.BUGSNAG_API_KEY) {
            Bugsnag.notify(new Error('Submission submit error'), {
              metaData: {
                promotion_id: promotionId,
                data: {submission: data},
                response: error.response,
                errors: error.response.data.error
              }
            });
          }
        }
      });
  }
}

export function verifySubmission(promotionId, data, formRef) {
  return dispatch => {
    dispatch(verifySubmissionRequest());
    return axios.put('/promotions/' + promotionId + '/submissions/verify', {submission: data})
      .then(response => {
        dispatch(verifySubmissionSuccess(response.data.submission));
        dispatch(push('/thanks'));
      }).catch(error => {
        dispatch(verifySubmissionFailure());
        if (error.response.data.max_attempts_reached) {
          dispatch(flashMessage('Maximum MFA attempts reached. You submission has been declined', {isError: true}));
          dispatch(push('/claim'));
        } else if (error.response.data.claim_limit_reached) {
          dispatch(flashMessage(error.response.data.error, {isError: true}));
          dispatch(push('/claim'));
        } else {
          formRef.current.updateInputsWithError({verification_code: error.response.data.error});
        }
      });
  }
}

export function verifySubmissionByToken(promotionId, token) {
  return dispatch => {
    dispatch(verifySubmissionRequest());
    return axios.put('/promotions/' + promotionId + '/submissions/verify_by_link', {token})
      .then(response => {
        dispatch(verifySubmissionSuccess(response.data.submission));
        dispatch(push('/thanks'));
      }).catch(error => {
        dispatch(verifySubmissionFailure());
        if (error.response.data.claim_limit_reached) {
          dispatch(flashMessage(error.response.data.error, {isError: true}));
          dispatch(push('/claim'));
        } else if (error.response.data.already_verified) {
          dispatch(flashMessage('Submission has already been verified', {props: {type: 'info'}}));
          dispatch(push('/claim'));
        } else {
          dispatch(flashMessage('Unable to verify your submission at this time', {isError: true}));
          dispatch(push('/claim'));
        }
      });
  }
}

export function fetchFailedSubmission(promotionId, token) {
  return dispatch => {
    dispatch(fetchFailedSubmissionRequest());
    return axios.get('/promotions/' + promotionId + '/failed_submissions', {params: {token}})
      .then(response => {
        dispatch(fetchFailedSubmissionSuccess(response.data.submission));
      }).catch(error => {
        dispatch(fetchFailedSubmissionFailure());
        dispatch(flashMessage('Claim not found', {isError: true}));
      });
  }
}

export function updateFailedSubmission(promotionId, token, data) {
  return dispatch => {
    dispatch(updateFailedSubmissionRequest());
    return axios.put('/promotions/' + promotionId + '/failed_submissions', {submission: data, token})
      .then(response => {
        dispatch(updateFailedSubmissionSuccess());
        dispatch(push('/update_success'));
        dispatch(flashMessage('Your claim details were updated successfully'));
      }).catch(error => {
        dispatch(updateFailedSubmissionFailure());
        dispatch(flashMessage(error.response.data.error, {isError: true}));
      });
  }
}

export function unsubscribe(promotionId, token, successCallback) {
  return dispatch => {
    return axios.post('/promotions/' + promotionId + '/submissions/unsubscribe', {token})
      .then(response => {
        successCallback();
      }).catch(error => {
        dispatch(push('/contact'));
        dispatch(flashMessage('Could not unsubscribe at this time, please try again later', {isError: true}));
      });
  }
}

export function fetchBankName(bsb) {
  return dispatch => {
    return axios.post('/bsb', {bsb})
      .then(response => {
        dispatch(fetchBankNameSuccess(response.data.bank_name));
      });
  }
}
